import { render, staticRenderFns } from "./PointNetridecashTechcoinForm.vue?vue&type=template&id=e5602712"
import script from "./PointNetridecashTechcoinForm.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports